import React, { useState, useEffect } from 'react';
import { Card, Form, Row, Col, Modal, Upload, Button, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

import { requiredMessages } from "../../utils/constants";
import { ModalFooterButtons } from '../../shared/components/modalFooterButtons/modalFooterButtons';

const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
};

const ReplaceDocumentPdfModal = ({ showDocumentReplacementModal, handelModalClose, loadingReplaceDocumentPdf, onDocumentPdfReplace }) => {
    const [uploadedFile, setUploadedFile] = useState(null);
    const [fileList, setFileList] = useState([]);
    const [fieldsChanged, setFieldsChanged] = useState(false);

    useEffect(() => {
        return () => {
            setUploadedFile(null);
            setFileList([]);
        };
    }, []);

    const beforeUpload = (file) => {
        const isPdf = file.type === 'application/pdf' || file.name.split(".").pop().toLowerCase() === "pdf";
        if (!isPdf) {
            message.error('You can only upload PDF files!');
            return false;
        }
        setUploadedFile(file);
        return false;
    };

    const handleChange = (info) => {
        if (info.file.status === 'removed') {
            setUploadedFile(null);
            setFileList([]);
        } else {
            setUploadedFile(info.file);
            setFileList([...info.fileList]);
            if (info.file.status === 'done') {
                message.success(`${info.file.name} file uploaded successfully`);
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        }
    };

    const handleUpload = (values) => {
        if (uploadedFile) {
            onDocumentPdfReplace(values);
        }
    };

    return (
        <Modal
            width={800}
            title="Carica PDF File"
            open={showDocumentReplacementModal}
            destroyOnClose
            onCancel={handelModalClose}
            footer={[
                <ModalFooterButtons
                    key="replaceDocumentPdf"
                    disabled={!uploadedFile}
                    loadingButton={loadingReplaceDocumentPdf}
                    modalClose={handelModalClose}
                    formId="replaceDocumentPdf"
                />
            ]}
        >
            <Card>
                <Form
                    id="replaceDocumentPdf"
                    layout="vertical"
                    {...formItemLayout}
                    onFinish={handleUpload}
                    onValuesChange={() => setFieldsChanged(true)}
                >
                    <Row gutter={{ lg: 24 }} className="row-margin">
                        <Col span={24}>
                            <Form.Item
                                label="PDF File"
                                name="file"
                                rules={[{ required: true, message: requiredMessages.requiredField }]}
                            >
                                <Upload
                                    accept='.pdf'
                                    maxCount={1}
                                    listType="picture"
                                    onChange={handleChange}
                                    beforeUpload={beforeUpload}
                                    onRemove={() => {
                                        setUploadedFile(null);
                                        setFileList([]);
                                    }}
                                >
                                    <Button icon={<UploadOutlined />}>Seleziona file</Button>
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </Modal>
    );
};

export default ReplaceDocumentPdfModal;
